import type { MailboxInfo } from 'owa-client-types';
import type { CopilotSettingsStore, ImplementedCopilotFeatures } from 'owa-copilot-settings-store';
import createStoreCheckForGenericEnablement from './createStoreCheckForGenericEnablement';

type ThreadSummarizationSydneyScenario = Extract<
    ImplementedCopilotFeatures,
    'ThreadSummarizationSydney'
>;

const isThreadSummarizationSydneyEnabled = (): ((
    scenario: ThreadSummarizationSydneyScenario,
    mailboxInfo: MailboxInfo
) => boolean | undefined) =>
    createStoreCheckForGenericEnablement<ThreadSummarizationSydneyScenario, boolean>(
        'ThreadSummarizationSydney',
        isThreadSummarizationSydneyEnabledInternal
    );

export default isThreadSummarizationSydneyEnabled;

function isThreadSummarizationSydneyEnabledInternal(
    store: CopilotSettingsStore,
    _language: string,
    scenario: ThreadSummarizationSydneyScenario
): boolean {
    const capabilities = store.featureInfo.get(scenario)?.capabilities;
    return (
        store.isEnabled &&
        capabilities !== undefined &&
        'threadSummarizationSydney' in capabilities &&
        capabilities.threadSummarizationSydney
    );
}
